<script>
    export let selected=0;
    export let data=false;

	import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();

	function inicial() { dispatch('page', { text: 0 }); }
	function anterior() { dispatch('page', { text: selected-1 }); }
	function siguiente() { dispatch('page', { text: selected+1 }); }
    function ultima() { dispatch('page', { text: (data.paginas-1) }); }

</script>
<style>
    A {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
            -ms-user-select: none; /* Internet Explorer/Edge */
                user-select: none; /* Non-prefixed version, currently*/
    }
</style>
{#if data!==false}
    <!-- svelte-ignore a11y-invalid-attribute -->
    <!-- svelte-ignore a11y-missing-attribute -->
    <nav aria-label="Page navigation example">
        <ul class="pagination justify-content-end ">
        {#if selected == 0 || data.resultados==0}
            <li class="page-item disabled">
                <a class="page-link bg-secondary text-white" on:click={inicial}>Inicial</a>
            </li>
            <li class="page-item disabled">
                <a class="page-link bg-secondary text-white" on:click={anterior}>Anterior</a>
            </li>
        {:else}
            <li class="page-item">
                <a class="page-link bg-warning text-dark" on:click={inicial}>Inicial</a>
            </li>
            <li class="page-item">
                <a class="page-link bg-warning text-dark" on:click={anterior}>Anterior</a>
            </li>
        {/if}

        {#if selected == (data.paginas-1)  || data.resultados==0}
            <li class="page-item disabled">
                <a class="page-link bg-secondary text-white">Siguiente</a>
            </li>
            <li class="page-item disabled">
                <a class="page-link bg-secondary text-white">Última</a>
            </li>
        {:else}
            <li class="page-item" on:click={siguiente}>
                <a class="page-link bg-warning text-dark">Siguiente</a>
            </li>
            <li class="page-item" on:click={ultima}>
                <a class="page-link bg-warning text-dark">Última</a>
            </li>
        {/if}

        
        </ul>
    </nav>
{/if}